@file:OptIn(InternalResourceApi::class)

package acessoescola.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/acessoescola.composeapp.generated.resources/"

@delegate:ResourceContentHash(2_088_687_059)
internal val Res.drawable.add_24px: DrawableResource by lazy {
      DrawableResource("drawable:add_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/add_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_986_589_228)
internal val Res.drawable.add_a_photo_24px: DrawableResource by lazy {
      DrawableResource("drawable:add_a_photo_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/add_a_photo_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(182_707_098)
internal val Res.drawable.add_photo_alternate_24px: DrawableResource by lazy {
      DrawableResource("drawable:add_photo_alternate_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/add_photo_alternate_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(508_072_163)
internal val Res.drawable.admin_panel_settings_24px: DrawableResource by lazy {
      DrawableResource("drawable:admin_panel_settings_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/admin_panel_settings_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-777_165_733)
internal val Res.drawable.arrow_right_alt_24px: DrawableResource by lazy {
      DrawableResource("drawable:arrow_right_alt_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_right_alt_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_250_591_487)
internal val Res.drawable.call_24px: DrawableResource by lazy {
      DrawableResource("drawable:call_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/call_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-465_680_713)
internal val Res.drawable.check_24px: DrawableResource by lazy {
      DrawableResource("drawable:check_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/check_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_317_562_746)
internal val Res.drawable.cloud_sync_24px: DrawableResource by lazy {
      DrawableResource("drawable:cloud_sync_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/cloud_sync_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(208_281_288)
internal val Res.drawable.content_copy_24px: DrawableResource by lazy {
      DrawableResource("drawable:content_copy_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/content_copy_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_388_629_446)
internal val Res.drawable.delete_24px: DrawableResource by lazy {
      DrawableResource("drawable:delete_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/delete_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-432_211_391)
internal val Res.drawable.download_24px: DrawableResource by lazy {
      DrawableResource("drawable:download_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/download_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_755_822_490)
internal val Res.drawable.edit_document_24px: DrawableResource by lazy {
      DrawableResource("drawable:edit_document_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/edit_document_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_940_621_943)
internal val Res.drawable.error_24px: DrawableResource by lazy {
      DrawableResource("drawable:error_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/error_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_043_833_562)
internal val Res.drawable.facial: DrawableResource by lazy {
      DrawableResource("drawable:facial", setOf(
        ResourceItem(setOf(), "${MD}drawable/facial.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-756_832_894)
internal val Res.drawable.id_card_24px: DrawableResource by lazy {
      DrawableResource("drawable:id_card_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/id_card_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_176_095_139)
internal val Res.drawable.lock_24px: DrawableResource by lazy {
      DrawableResource("drawable:lock_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/lock_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(460_976_780)
internal val Res.drawable.logout_24px: DrawableResource by lazy {
      DrawableResource("drawable:logout_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/logout_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_719_244_249)
internal val Res.drawable.loyola_24px: DrawableResource by lazy {
      DrawableResource("drawable:loyola_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/loyola_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_253_313_460)
internal val Res.drawable.microsoft_color: DrawableResource by lazy {
      DrawableResource("drawable:microsoft_color", setOf(
        ResourceItem(setOf(), "${MD}drawable/microsoft_color.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_637_444_761)
internal val Res.drawable.person_24px: DrawableResource by lazy {
      DrawableResource("drawable:person_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/person_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-746_712_456)
internal val Res.drawable.search_activity_24px: DrawableResource by lazy {
      DrawableResource("drawable:search_activity_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/search_activity_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_115_752_683)
internal val Res.drawable.sync_24px: DrawableResource by lazy {
      DrawableResource("drawable:sync_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/sync_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(969_949_855)
internal val Res.drawable.visibility_24px: DrawableResource by lazy {
      DrawableResource("drawable:visibility_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/visibility_24px.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_594_904_861)
internal val Res.drawable.visibility_off_24px: DrawableResource by lazy {
      DrawableResource("drawable:visibility_off_24px", setOf(
        ResourceItem(setOf(), "${MD}drawable/visibility_off_24px.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("add_24px", Res.drawable.add_24px)
  map.put("add_a_photo_24px", Res.drawable.add_a_photo_24px)
  map.put("add_photo_alternate_24px", Res.drawable.add_photo_alternate_24px)
  map.put("admin_panel_settings_24px", Res.drawable.admin_panel_settings_24px)
  map.put("arrow_right_alt_24px", Res.drawable.arrow_right_alt_24px)
  map.put("call_24px", Res.drawable.call_24px)
  map.put("check_24px", Res.drawable.check_24px)
  map.put("cloud_sync_24px", Res.drawable.cloud_sync_24px)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("content_copy_24px", Res.drawable.content_copy_24px)
  map.put("delete_24px", Res.drawable.delete_24px)
  map.put("download_24px", Res.drawable.download_24px)
  map.put("edit_document_24px", Res.drawable.edit_document_24px)
  map.put("error_24px", Res.drawable.error_24px)
  map.put("facial", Res.drawable.facial)
  map.put("id_card_24px", Res.drawable.id_card_24px)
  map.put("lock_24px", Res.drawable.lock_24px)
  map.put("logout_24px", Res.drawable.logout_24px)
  map.put("loyola_24px", Res.drawable.loyola_24px)
  map.put("microsoft_color", Res.drawable.microsoft_color)
  map.put("person_24px", Res.drawable.person_24px)
  map.put("search_activity_24px", Res.drawable.search_activity_24px)
  map.put("sync_24px", Res.drawable.sync_24px)
  map.put("visibility_24px", Res.drawable.visibility_24px)
  map.put("visibility_off_24px", Res.drawable.visibility_off_24px)
}
